import { createSlice } from '@reduxjs/toolkit';
const initialState = {
    data: null,
    loading: false,
    error: null,
    lastCheckedDocument: null,
};
const hasAccessSlice = createSlice({
    name: 'hasAccess',
    initialState,
    reducers: {
        setHasAccessLoading: (state, action) => {
            state.loading = action.payload;
        },
        setHasAccessData: (state, action) => {
            state.data = action.payload.data;
            state.lastCheckedDocument = action.payload.documentNumber;
            state.error = null;
        },
        setHasAccessError: (state, action) => {
            state.error = action.payload;
            state.loading = false;
        },
        clearHasAccessData: state => {
            state.data = null;
            state.error = null;
            state.loading = false;
            state.lastCheckedDocument = null;
        },
    },
});
export const { setHasAccessLoading, setHasAccessData, setHasAccessError, clearHasAccessData } = hasAccessSlice.actions;
export default hasAccessSlice.reducer;
